import { createContext, useContext } from 'react';
import { StoreApi } from 'zustand';
import { DataStore } from '@/widget/services/useChatWidgetStore';

export type SettingsType = {
  host: string;
  token: string;
  wsUrl: string;
  lang: string;
  position: 'left' | 'right';
  privatePolicyUrl: string;
  color: string;
  logoUrl: string;
  textOnline: string;
  textOffline: string;
  invitationText: string;
  isMobile: boolean;
  customTrigger: boolean;
  textColor: string;
  quickAnswers: string[];
  channels: {
    link: string;
    type: string;
  }[];
  links: {
    name: string;
    url: string;
  }[];
  formFields: string[];
};

type ChatWidgetContext = {
  store: StoreApi<DataStore> | null;
  settings: SettingsType | null,
};

const defaultValue: ChatWidgetContext = {
  store: null,
  settings: null,
};

const ChatWidgetContext = createContext(defaultValue);

export default ChatWidgetContext;

export function useChatWidgetContext() {
  return useContext(ChatWidgetContext);
}
